import React, { useState } from 'react';
import { useUser } from '../utils/UserContext';
import TabBar from '../components/shared/TabBar';
import InnerTabsm from '../components/shared/InnerTabsm';
import { DocumentIcon2, UserIcon2, RocketIcon, DollarIcon, LockIcon } from '../components/shared/Icons';
import FilteredPayments from '../components/payments/FilteredPayments';
import ChangePassword from './ChangePassword';
import PersonalDetails from './PersonalDetails';
import DocPolicies from './DocPolicies';
import ToOnboarding from './ToOnboarding';
import MobileTraining from '../components/training/MobileTraining';

const TABS = [
  {
    id: 'personal',
    label: 'Personal',
    
  },
  {
    id: 'dochub',
    label: 'On-Boarding',
    
  },
  
  
];


const DOCHUB_INNER = [
  { id: 'snldocs', label: 'Policies', icon: <DocumentIcon2 />, component: DocPolicies },
   { id: 'toonboarding', label: 'Doc-Hub', icon: <UserIcon2/>, component: () => <ToOnboarding userType="Existing" /> },
  { id: 'training', label: 'Training', icon: <RocketIcon />, component: MobileTraining },
 

  
  
];

const PERSONAL_INNER = [
  { id: 'payments', label: 'Money', icon: <DollarIcon />, component: FilteredPayments },
  { id: 'personals', label: 'User Details', icon: <UserIcon2 />, component: PersonalDetails },
  { id: 'password', label: 'Password', icon: <LockIcon />, component: ChangePassword },
];



const FilterSuperPersonalOnboardPagem = () => {
  const [activeTab, setActiveTab] = useState('personal');
  const { homeAccent } = useUser();
  

  return (
    <div className="fr-tab-page">
      <TabBar
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        homeRoute="/profile"
        homeColor={homeAccent}
      />
      <div className="fr-tab-content">
        {activeTab === 'personal' && <InnerTabsm tabs={PERSONAL_INNER} defaultId='payments'/>}
        {activeTab === 'dochub' && <InnerTabsm tabs={DOCHUB_INNER} defaultId="snldocs"/>}
        
       
      </div>
    </div>
  );
};

export default FilterSuperPersonalOnboardPagem;